export const filters = countryList => {
  return {
    RegularFilters: [
      {
        label: 'status',
        field: 'status',
        type: 'select',
        options: companyStatusOptions,
      },
      {
        label: 'country',
        field: 'country',
        type: 'select',
        options: countryList,
      },
      {
        label: 'dateReceived',
        field: 'dateReceived',
        type: 'date-picker',
      },
    ],
  };
};
export const companyStatusOptions = [
  { id: 'PENDING', name: 'pending' },
  { id: 'APPROVED', name: 'approved' },
  { id: 'REJECTED', name: 'rejected' },
];
